import { usePrivy } from "@privy-io/react-auth";

function truncate(addr: string): string {
  if (addr.length <= 10) return addr;
  return `${addr.slice(0, 6)}…${addr.slice(-4)}`;
}

export function ConnectButton() {
  const { login, logout, authenticated, user, ready } = usePrivy();

  const address = user?.wallet?.address;
  const label = authenticated && address ? truncate(address) : "CONNECT";

  const handleClick = () => {
    if (!ready) return;
    if (authenticated) {
      void logout();
    } else {
      login();
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={!ready}
      style={{
        fontFamily: "var(--f-mono)",
        fontSize: 10,
        letterSpacing: "0.12em",
        textTransform: "uppercase",
        fontWeight: 600,
        padding: "7px 12px",
        background: authenticated ? "transparent" : "var(--brand)",
        color: authenticated ? "var(--fg-hi)" : "var(--bg-0)",
        border: `1px solid ${authenticated ? "var(--line-3)" : "var(--brand)"}`,
        cursor: ready ? "pointer" : "not-allowed",
        borderRadius: 2,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </button>
  );
}
